<div class="dialog-container">
  <img
    class="close-button"
    src="assets/images/XCloseIcon.svg"
    alt="close"
    mat-dialog-close />
  <div class="row">
    <div class="col-12 modal-title">Service Schedule History</div>
  </div>
  <ng-container
    *ngIf="
      (inactiveServiceSchedules$ | async).length > 0;
      else noInactiveServiceSchedules
    ">
    <app-service-schedules
      [serviceSchedules]="inactiveServiceSchedules$ | async"
      [isModal]="true">
    </app-service-schedules>
  </ng-container>
  <ng-template #noInactiveServiceSchedules>
    <app-no-data message="No service schedule history"></app-no-data>
  </ng-template>
</div>
